import { ApiResponseState } from "#shared/enums";

export const statusOk = (status: string | number): boolean => {
  if (typeof status === "string") {
    return (
      status === ApiResponseState.OK ||
      status === ApiResponseState.SUCCESS
    );
  }

  if (typeof status === "number") {
    return status >= 200 && status < 300;
  }

  return false;
};

// export const getCreateLink = () => {
//   const app_env = import.meta.env.MODE;
//   if (app_env === "production") {
//     return "https://trypebble.com";
//   } else if (app_env === "test" || app_env === "staging") {
//     return "https://test.trypebble.com";
//   } else if (app_env === "development" || app_env === "local") {
//     return "http://localhost:3001";
//   } else {
//     return "http://localhost:3001";
//   }
// };